import { useCallback, useRef } from "react";

export const useFocusOnce = () => {
  const ref = useRef(null);
  const setRef = useCallback(node => {
    if (!ref.current && node) {
      node.focus();
    }
    ref.current = node;
  }, []);

  return [ref, setRef];
};
